export const msalConfig = {
  auth: {
    clientId: '377638bc-13fc-4901-8460-0562b070c4d3', // Application (client) ID from the app registration
    authority:
      'https://login.microsoftonline.com/8bc97f9a-ea86-472e-8ab7-19db58c4c8af/v2.0/.well-known/openid-configuration', // The Azure cloud instance and the app's sign-in audience (tenant ID, common, organizations, or consumers)
    redirectUri: `${window.location.origin}`, // This is your redirect URI
  },
  cache: {
    cacheLocation: 'localStorage', // 👈 Ensures the session is persistent
    storeAuthStateInCookie: false, // 👈 Helps prevent session loss in certain browsers
  },
};

export const loginRequest = {
  scopes: ['User.Read'],
};
